import { render, staticRenderFns } from "./MainBanner.vue?vue&type=template&id=3362af4d&scoped=true&"
import script from "./MainBanner.vue?vue&type=script&lang=ts&"
export * from "./MainBanner.vue?vue&type=script&lang=ts&"
import style0 from "./MainBanner.vue?vue&type=style&index=0&id=3362af4d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3362af4d",
  null
  
)

export default component.exports